export default __webpack_public_path__ + "7fae93ee70c64f6444cf15bc56c7b4bb.mov";